import { render, staticRenderFns } from "./BlockType4List.vue?vue&type=template&id=095437b6&scoped=true&"
import script from "./BlockType4List.vue?vue&type=script&lang=ts&"
export * from "./BlockType4List.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType4List.vue?vue&type=style&index=0&id=095437b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095437b6",
  null
  
)

export default component.exports